import { FC } from "react"
import { IconProps } from "@/components/shared/Icon"

const BrushIcon: FC<IconProps> = ({ ...props }) => {
   return (
      <svg
         viewBox="0 0 17.454544067382812 24"
         fill="none"
         {...props}
      >
         <path
            fill="currentColor"
            d="M2.182 13.5V3a.74.74 0 0 1 .727-.75h1.455v4.5c0 .412.327.75.727.75.4 0 .727-.338.727-.75v-4.5h2.91v3c0 .412.327.75.727.75.4 0 .727-.338.727-.75v-3h4.364c.4 0 .727.337.727.75v10.5H2.182ZM0 15c0 1.655 1.305 3 2.91 3h2.908v3c0 1.655 1.305 3 2.91 3 1.604 0 2.908-1.345 2.908-3v-3h2.91c1.604 0 2.909-1.345 2.909-3V3c0-1.655-1.305-3-2.91-3H2.91C1.305 0 0 1.345 0 3v12Zm8.727 5.25c.193 0 .378.079.515.22a.762.762 0 0 1 0 1.06.716.716 0 0 1-.515.22.716.716 0 0 1-.514-.22A.762.762 0 0 1 8 21c0-.199.077-.39.213-.53a.716.716 0 0 1 .514-.22Z"
         />
      </svg>
   )
}

export default BrushIcon
